// extracted by mini-css-extract-plugin
module.exports = {"root":"PhotosBlockForm_root__11Xr2","items":"PhotosBlockForm_items__2rt-l","item":"PhotosBlockForm_item__25d6L","addButton":"PhotosBlockForm_addButton__1zMcB"};